export default __webpack_public_path__ + "static/media/AM.8a528ba9.jpg";